const DEFAULT_AVATAR =
  "https://api.dicebear.com/7.x/avataaars/svg?seed=default";

interface RivalCardProps {
  username: string | null;
  avatarUrl: string | null;
  distanceAhead: number;
  isWinner?: boolean;
}

export function RivalCard({
  username,
  avatarUrl,
  distanceAhead,
  isWinner = true,
}: RivalCardProps) {
  return (
    <div className="rounded-2xl bg-[#1e1e1e] p-4 border border-white/5 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="relative">
          <img
            alt="Rival"
            className="size-12 rounded-full object-cover border-2 border-primary/50"
            src={avatarUrl || DEFAULT_AVATAR}
          />
          <div className="absolute -bottom-1 -right-1 bg-white/20 backdrop-blur-md text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full border border-white/10">
            RIVAL
          </div>
        </div>
        <div>
          <p className="text-sm font-bold text-white">
            {username || "Anonymous"}
          </p>
          <p className="text-xs text-white/50">
            {isWinner
              ? `Was just ${distanceAhead.toFixed(1)}km ahead of you!`
              : "Finished just ahead of you."}
          </p>
        </div>
      </div>
      <button className="size-8 rounded-full bg-white/5 flex items-center justify-center text-white hover:bg-white/10">
        <span className="material-symbols-outlined text-sm">waving_hand</span>
      </button>
    </div>
  );
}
